import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import * as Sentry from "@sentry/react";
import "@/index.css";
import App from "@/App";
import { APP_VERSION } from "@/lib/version";

// Optional error tracking: activates only when REACT_APP_SENTRY_DSN is set at build
// time, so preview/local runs behave identically and it "turns on" once the key is set.
const sentryDsn = process.env.REACT_APP_SENTRY_DSN;
const sentryEnabled = !!(sentryDsn && sentryDsn.trim());
if (sentryEnabled) {
  Sentry.init({
    dsn: sentryDsn,
    environment: process.env.NODE_ENV,
    release: process.env.REACT_APP_SENTRY_RELEASE || `twp-co@${APP_VERSION}`,
  });
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const tree = (
  <QueryClientProvider client={queryClient}>
    <App />
  </QueryClientProvider>
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    {sentryEnabled ? (
      <Sentry.ErrorBoundary
        fallback={
          <main role="alert" className="p-6 text-sm text-zinc-600">
            Something went wrong. Please reload the page.
          </main>
        }
      >
        {tree}
      </Sentry.ErrorBoundary>
    ) : (
      tree
    )}
  </React.StrictMode>,
);

// Register service worker so the app is installable as a PWA
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker.js", { scope: "/" }).catch(() => {});
  });
}
